import { FAQ_ARROW_DOWN, FAQ_ARROW_UP } from "../../../utils/images";
import classes from "./foldableCardSummerCamp.module.css";
export default function FoldableCardSummerCamp({
  title,
  content,
  children,
  isOpenedStates,
  className,
  withoutBorder,
  index,
  setIsOpenedStates,
}) {
  const onTitleClick = () => {
    setIsOpenedStates((prev) => {
      const newOpenedStates = [...prev];
      newOpenedStates[index] = !newOpenedStates[index];
      return newOpenedStates;
    });
  };
  const className_ = `${
    withoutBorder ? classes.containerWithoutBorder : classes.container
  } ${className}`;
  return (
    <div
      className={`${className_} ${
        !isOpenedStates[index] ? classes.selectedFaqContainer : ""
      }`}
      onClick={onTitleClick}
      itemType="http://schema.org/Question"
      itemProp="mainEntity"
      itemScope=" "
    >
      <div className={classes.header}>
        <div className={classes.title} itemProp={"name"}>
          {title}
        </div>
        <img
          alt={`Drop ${isOpenedStates[index] ? "Down" : "Up"} Arrow`}
          src={isOpenedStates[index] ? FAQ_ARROW_DOWN : FAQ_ARROW_UP}
          width={56}
          height={56}
          className={classes.dropDownIcon}
        />
      </div>
      <div
        className={`${
          isOpenedStates[index] ? classes.contentNone : classes.content
        }`}
        itemType="http://schema.org/Answer"
        itemProp="acceptedAnswer"
        itemScope=" "
      >
        <span itemProp="text">{content || children}</span>
      </div>
    </div>
  );
}
